import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    data: function () {
        return {
            IsInitComplete: false,
            ShowAFK: false,
            ShowLegendVPN: false,
            ShowLegendTelegram: false,

            AFKAndroidUrl: '',
            AFKiosUrl: '',
            AFKPcUrl: '',
            AFKAndroidFile: '',
            AFKPcFile: '',
            AndroidAPPFile: '',
            AndroidAPPUrl: '',
            IOSPlistPath: '',
            LoginUrl: '',
            CordovaAppVersion: '',
            LegendAFKAndroidUrl: '',
            LegendAFKiosUrl: '',
            LegendAFKPCUrl: '',
            LegendAFKTelegramGuideUrl: '',
            LegendAFKVpnGuideUrl: '',
            AFKZCBPcUrl:'',
            SmartAFKUrl:'',
            

            QrcodeOptions: {
                width: 150,
                margin: 1
            },
        };
    },
    components: {
        qrcode: VueQrcode
    },
    computed: {
        AFKAndroidObj: function () {
          return new UrlAttr(this.AFKAndroidUrl);
        },
        AFKiosObj: function () {
            return new UrlAttr(this.AFKiosUrl);
        },
        AFKPcObj: function () {
            return new UrlAttr(this.AFKPcUrl);
        }
    },
    methods: {
        async Init() {
            let _this = this;

            try {

                let result = await $.get('/api/AFK/GetAFKConfig');

                _this.IsInitComplete = true;

                _this.AFKAndroidUrl = result.AFKAndroidUrl;
                _this.AFKiosUrl = result.AFKiosUrl;
                _this.AFKPcUrl = result.AFKPcUrl;
                _this.AFKAndroidFile = result.AFKAndroidFile;
                _this.AFKPcFile = result.AFKPcFile;
                _this.AndroidAPPFile = result.AndroidAPPFile;
                _this.AndroidAPPUrl = result.AndroidAPPUrl;
                _this.IOSPlistPath = result.IOSPlistPath;
                _this.CordovaAppVersion = result.CordovaAppVersion;
                _this.LegendAFKAndroidUrl = result.LegendAFKAndroidUrl;
                _this.LegendAFKiosUrl = result.LegendAFKiosUrl;
                _this.LegendAFKPCUrl = result.LegendAFKPCUrl;
                _this.LegendAFKVpnGuideUrl = result.LegendAFKVpnGuideUrl;
                _this.LegendAFKTelegramGuideUrl = result.LegendAFKTelegramGuideUrl;
                _this.SmartAFKUrl = result.SmartAFKUrl;
                _this.ShowAFK = _this.IsShowAFK();
                _this.ShowLegendVPN = _this.LegendAFKVpnGuideUrl !== '';
                _this.ShowLegendTelegram = _this.LegendAFKTelegramGuideUrl !== '';
            }
            catch (err) {
                console.error(err);
                //_this.$dialog.warning("伺服器错误，请重新尝试!!");  //共用區選項不顯示該訊息，避免跳轉到維護頁時多該訊息
            }
        },
        IsShowAFK() {
            return this.AFKAndroidUrl || this.AFKiosUrl || this.AFKPcUrl;
        }
    },
    async mounted() {
        await this.Init();
    }
}



class UrlAttr {
    constructor(_href) {
        this.href = this.ConvertUrl(_href);
        this.target = this.actionTarget(_href);

        return {
            href : this.href,
            target : this.target
        };
    }

    ConvertUrl(val){
        return typeof val == "undefined" || val == "" ? "javascript:void(0);" : val;
    }

    actionTarget(value) {
        return typeof val == "undefined" || value == '' ? '_self' : '_blank';
    }
}